export const STATS_LABELS: { [s: string]: string } = {
  totalDayJobs: 'Total Day Jobs',
  dayJobsOpen: 'Day Jobs Open',
  dayReplacementsOpen: 'Day Replacements Open',
  dayJobsNotPublished: 'Day Not Published',
  totalNightJobs: 'Total Night Jobs',
  nightJobsOpen: 'Night Jobs Open',
  nightReplacementsOpen: 'Night Replacements Open',
  nightJobsNotPublished: 'Night Not Published'
}